import styled from "styled-components";

export const SpeechBoxWrapper = styled.div`
  width: 200px;
  min-height: 40px;
  background-color: white;
  border: 1px solid black;
  border-radius: 8px;
  margin: 10px 0;
  position: absolute;
  padding: 5px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;
